import { render, staticRenderFns } from "./MicrosoftSSO.vue?vue&type=template&id=327261b7"
import script from "./MicrosoftSSO.vue?vue&type=script&lang=js"
export * from "./MicrosoftSSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports